import axios from './axios'

function service(endpoint) {

    function createDecisionMaker(id) {
        return axios.post(`${endpoint}/${id}/decisionMaker`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        createDecisionMaker
    }
}

export default service
